/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

export interface ApiResponse<T = any> {
  result: {
    code: number;
    message: string;
    success: boolean;
  };
  data: T;
  meta?: {
    offset: number;
    limit: number;
    total: number;
  };
}

export enum API_RESPONSE_TYPES {
  ENTITY_NOT_FOUND = 'Entity not found.',
  ENTITY_ALREADY_EXISTS = 'Entity already exists.',
}

export function mockSuccessResponse(data: any): ApiResponse {
  return {
    result: {
      code: 200,
      message: '',
      success: true,
    },
    data,
  };
}
